// Kampanya tür rozeti — deriveCampaignKind tonuna göre renklendirir.
const TONE_STYLES = {
  navy: { bg: '#1e3a8a', fg: '#ffffff' },
  green: { bg: '#15803d', fg: '#ffffff' },
  amber: { bg: '#d97706', fg: '#ffffff' },
  blue: { bg: '#2563eb', fg: '#ffffff' },
  purple: { bg: '#7c3aed', fg: '#ffffff' },
  neutral: { bg: '#e5e7eb', fg: '#374151' },
};

export function CampaignTypeBadge({ kind }) {
  const tone = TONE_STYLES[kind?.tone] || TONE_STYLES.neutral;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 10px',
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 700,
        lineHeight: 1.4,
        whiteSpace: 'nowrap',
        background: tone.bg,
        color: tone.fg,
      }}
    >
      <span aria-hidden="true" style={{ opacity: 0.85 }}>◆</span>
      {kind?.label || '-'}
    </span>
  );
}

export default CampaignTypeBadge;
